import Resource from '@/plugins/sdk/Resource'
import { NUMBER, INTEGER, STRING, UUID, ITEM, COLLECTION, BOOLEAN } from '@/plugins/sdk/fields'
import ItemType from '../Dictionary/ItemType'
import Contents from './Item/Contents'
import ItemsDg from '../Account/ItemsDg'

export default class extends Resource {
  static name = 'consignment_item'

  static get fields () {
    return {
      id: new UUID(),
      reference: new STRING(),
      item_full: new STRING(),
      item_no: new INTEGER(),
      item_qty: new INTEGER(),
      item_ref: new STRING(),
      item_weight: new NUMBER(),
      item_cube: new NUMBER(),
      item_length: new INTEGER(),
      item_width: new INTEGER(),
      item_height: new INTEGER(),
      item_desc: new STRING(),
      item_barcode: new STRING(),
      itemdg_id: new STRING(),
      itemdg_weight: new NUMBER(),
      itemdg_desc: new STRING(),
      item_group: new INTEGER(),
      item_type: new INTEGER(),
      type: new ITEM(ItemType),
      dg: new ITEM(ItemsDg),
      contents: new COLLECTION(Contents),
      item_edn: new STRING(),
      item_commercial_value: new BOOLEAN(),
      item_export_desc: new STRING()
    }
  }
}
